import RegisterBtnComponent from '@components/Default/Register/RegisterBtnComponent';
import SearchComponent from '@components/Default/Search/SearchComponent';
import Page from '@components/Page';
import SelectableDataComponent from '@components/SelectableDataComponent';
import UploadModelComponent from '@components/UploadModelComponent';
import { IModel3D } from '@interfaces/IModel3D';
import IPagination from '@interfaces/IPagination';
import IUnit from '@interfaces/IUnit';
import Model3DService from '@services/qa/Model3DService';
import UnitService from '@services/Unit';
import NotificationComponent from '@src/helpers/_showNotifications';
import I18n from '@src/i18n';
import styled, { Theme } from '@src/styled-components';
import { Button, Col, Form, Input, Modal } from 'antd';
import findIndex from 'lodash/findIndex';
import * as React from 'react';

import Table from '../components/TableComponent';
import { LocalStorageKeys } from './App';

export interface IUploadModel3DContainerProps {
  form: any;
}

export interface IUploadModel3DContainerState {
  isLoading: boolean;
  search: string;
  tableData: IModel3D[],
  filteredTableData: IModel3D[],
  offset?: string,
  loadingMoreFormflows?: boolean,
  loadingRequest?: boolean,
  serverResponse: any;
  openModel3dRegister: boolean;
  openModel3dEdit: boolean;

  unitsData: IUnit[],
  selectedProcessId?: string;
  showUnitSelectModal: boolean;
  selectedProcessObject?: IModel3D;
  unitsAlreadySaved: string[];
  actualUnit?: IUnit;

  modelValidator: string;
  imageFileList: any[];
  imageUpload: any;
  modelValidatorType: boolean | null;
  editItem?: IModel3D;
  isLoadingModel: boolean;
}

const tableColumns = [{
  title: 'table.formflow.name',
  dataIndex: 'name',
  key: 'name',
  class: 'name',
  width: '30%'
}, {
  title: 'table.actions',
  dataIndex: 'action',
  key: 'action',
  width: '20%'
}];

const _mode3dService: Model3DService = new Model3DService();
const _unitsService: UnitService = new UnitService();

export default class Model3DClass extends React.Component<IUploadModel3DContainerProps, IUploadModel3DContainerState> {

  private idUnit: string;

  constructor(props: IUploadModel3DContainerProps) {
    super(props);
    this.idUnit = String(localStorage.getItem(LocalStorageKeys.ACTIVE_UNIT_ID))
    this.state = {
      isLoading: true,
      loadingRequest: false,
      search: '',
      tableData: [],
      filteredTableData: [],
      serverResponse: undefined,
      openModel3dRegister: false,
      openModel3dEdit: false,
      showUnitSelectModal: false,
      unitsData: [],
      selectedProcessObject: undefined,
      unitsAlreadySaved: [],

      modelValidator: '',
      imageFileList: [],
      imageUpload: '',
      modelValidatorType: null,
      isLoadingModel: true
    }

    this.getModels3Ds = this.getModels3Ds.bind(this);
    this.searchModels3d = this.searchModels3d.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.deleteModel3d = this.deleteModel3d.bind(this);
    this.loadMoreModel3d = this.loadMoreModel3d.bind(this);
    this.onEditModel3d = this.onEditModel3d.bind(this);
    this.getUnits = this.getUnits.bind(this);
    this.toggleUnitSelectModal = this.toggleUnitSelectModal.bind(this);
    this.onRemoveUnit = this.onRemoveUnit.bind(this);
    this.onAddUnit = this.onAddUnit.bind(this);
    this.unitAdded = this.unitAdded.bind(this);
    this.unitRemoved = this.unitRemoved.bind(this);

    this.setUnit(this.idUnit || '');

  }

  componentDidMount() {

    this.setState({ isLoading: true });
    this.getUnits(true);
  }

  setUnit(unitId: string) {
    this.idUnit = unitId;
  }

  async getUnits(showLoading?: boolean) {
    if (showLoading != undefined) { this.setState({ isLoading: showLoading }) };

    try {
      const data: IUnit[] = await _unitsService.listAll(['id', 'name']);

      let newUnitsData: any[] = [];
      let actualUnitObject: any;

      if (data && data.length > 0) {
        newUnitsData = data.filter((item: IUnit) => item.id != this.idUnit);

        actualUnitObject = data.find((unit: IUnit) => unit.id === this.idUnit);
      }

      this.setState({ unitsData: newUnitsData, actualUnit: actualUnitObject });
    } catch (error) {
      console.warn(error);
      this.setState({
      });
    }
    this.getModels3Ds(true, true);
  };


  async getModels3Ds(reset: boolean, showLoading?: boolean) {
    if (showLoading != undefined) { this.setState({ isLoading: showLoading }) };

    if (reset) {
      this.setState({
        offset: undefined
      });
    }
    try {
      const response: IPagination<IModel3D> = await _mode3dService.paging({
        unit: this.idUnit,
        to: undefined,
        from: undefined,
        search: this.state.search,
        limit: 10,
        offset: this.state.offset
      });

      let dataTableCreate: any = [];

      if (!reset) {
        dataTableCreate = this.state.tableData || [];
      }

      dataTableCreate = dataTableCreate.concat(this.formatDataToTable(response.items));
      this.setState({ tableData: dataTableCreate, isLoading: false, offset: response.offset, loadingMoreFormflows: false });
    } catch (e) {
      NotificationComponent.Notify('error', I18n.l('common.error'), e);
      this.setState({ isLoading: false, loadingMoreFormflows: false });
    }
  }
  toggleFormModal = async () => {
    console.log('MODEL INITIALAA CREATE', this.state.modelValidator)
    this.setState({
      openModel3dRegister: !this.state.openModel3dRegister,
      // serverResponse: undefined,
      editItem: {
        id: '',
        name: '',
        url: ''
      },
      modelValidator: ''
    });
    this.props.form.setFieldsValue(
      {
        name: '',
      });
  }

  toggleFormModalEdit = async () => {
    console.log('MODEL INITIALAA', this.state.modelValidator)

    this.setState({
      openModel3dEdit: !this.state.openModel3dEdit,
      // serverResponse: undefined,
      editItem: {
        id: '',
        name: '',
        url: ''
      },
      modelValidator: ''
    });
  }

  /// Get the data from api and format to fit correctly in the table
  formatDataToTable(data: IModel3D[]) {
    if (data === undefined || data.length === 0) { return [] };

    const formatedData: any = [];

    data.map((mode3d: IModel3D, i: number) => {
      const linkUnitInfo = (
        <Col >
          <a href="#" onClick={() => this.toggleUnitSelectModal(mode3d.id || '')}>{I18n.l('table.formflow.linkUnits')}</a>
        </Col>
      );
      formatedData.push({
        key: mode3d.id,
        id: mode3d.id,
        name: mode3d.name || "-",
        units: mode3d.units,
        url: mode3d.url,
        linkUnits: linkUnitInfo,
      })
    })

    return formatedData;
  }

  async onSubmit() {
    this.setState({ loadingRequest: true })
    try {
      this.setState({ loadingRequest: false })
    } catch (e) {
      NotificationComponent.Notify('error', I18n.l('common.error'), e);
      this.setState({ loadingRequest: false })
    }
  }

  async deleteModel3d(id: string) {
    try {
      const { tableData } = this.state;
      await _mode3dService.deleteById(id, this.idUnit);

      const nextTableData = tableData.filter((item: IModel3D) => item.id !== id);
      this.setState({
        isLoading: false,
        tableData: nextTableData,
      });
      await NotificationComponent.Notify('success', I18n.l("common.success"), I18n.l("model3d.deleteModel"));
    } catch (e) {
      NotificationComponent.Notify('error', I18n.l("form.filter.errors.register"), e);
    }
  }

  loadMoreModel3d() {
    this.setState({ loadingMoreFormflows: true });
    this.getModels3Ds(false, false);
  }
  formatImageList = async (model3d: any) => {
    let imgList: any[] = [];

    if (model3d.url !== "" && model3d.url && model3d.url !== '-')
      imgList.push({
        uid: '1',
        name:  I18n.l('formflow.components.modelComponent.modelDownload'),
        url: model3d.url || "",
        thumbUrl: model3d.url || "",
        status: 'done'
      });

    return imgList;
  }

  async onEditModel3d(editItem: IModel3D) {
    let defaultModel = await this.formatImageList(editItem) || [];
    this.setState({
      openModel3dEdit: true,
      editItem: {
        id: editItem.id,
        name: editItem.name,
        url: editItem.url
      },
      modelValidator: '',
      imageFileList: defaultModel
    })
    console.log('MODEL INITIALAA', this.state.modelValidator)

    this.props.form.setFieldsValue(
      {
        name: editItem.name,
        url: editItem.url
      });

    console.log('EditItem', editItem)
  }

  searchModels3d = async (event: any) => {
    event.preventDefault();
    await this.setState({
      search: event.target.find.value,
      isLoading: true
    })
    if (event === '') {
      await this.setState({
        search: ''
      })
    }
    await this.setState({
      isLoading: true,
    })
    this.getModels3Ds(true, true);
  }

  //#region UNIT SELECTION MODAL

  async toggleUnitSelectModal(processId?: string) {
    this.setState({ selectedProcessId: processId || '' })

    await this.updateSelectedProcessObject();
    if (processId) this.getProcessUnitsIds(processId);

    this.setState({
      showUnitSelectModal: !this.state.showUnitSelectModal,
    });
  }

  async updateSelectedProcessObject() {
    const { selectedProcessId, tableData } = this.state;
    let selectedProcess = undefined;
    selectedProcess = await tableData.find((item: any) => item.id === selectedProcessId);
    this.setState({ selectedProcessObject: selectedProcess });
  }

  async getProcessUnitsIds(processId: string) {
    this.setState({ unitsAlreadySaved: [] });
    const { tableData, unitsData } = this.state;

    if (tableData === undefined || tableData.length === 0) {
      return;
    }
    const process = tableData.filter((item: any) => item.id == processId);
    const newUnitsSavedData: string[] = process[0].units || [];


    this.setState({ unitsAlreadySaved: newUnitsSavedData });
  }

  async onRemoveUnit(id: string) {
    const { selectedProcessId } = this.state;
    await this.setLoadingUnitData(id, true);

    if (selectedProcessId == undefined) {
      this.setLoadingUnitData(id, false);
      return;
    }
    try {
      await _mode3dService.unitRemove(selectedProcessId, id, this.idUnit);
      this.unitRemoved(id);
      this.setLoadingUnitData(id, false);
    } catch (e) {
      this.setLoadingUnitData(id, false);
      console.log("On remove unit error: ", e);
      NotificationComponent.NotifyWithMoreDuration('error', I18n.l('common.error'), e);
    }
  }

  async onAddUnit(id: string) {
    const { selectedProcessId } = this.state;
    this.setLoadingUnitData(id, true);

    if (selectedProcessId == undefined) {
      this.setLoadingUnitData(id, false);
      return;
    }

    try {
      await _mode3dService.unitAdd(selectedProcessId, id, this.idUnit);
      this.unitAdded(id);
      this.setLoadingUnitData(id, false);
    } catch (e) {
      this.setLoadingUnitData(id, false);
      console.log("On add unit error: ", e);
      NotificationComponent.NotifyWithMoreDuration('error', I18n.l('common.error'), e);
    }
  }

  async unitAdded(id: string) {
    const { unitsAlreadySaved } = this.state;

    const newAlreadySaved: any[] = [...unitsAlreadySaved];
    newAlreadySaved.push(id);

    this.setState({ unitsAlreadySaved: newAlreadySaved });
    this.setUnitsToUser();
  }

  async unitRemoved(id: string) {
    const { unitsAlreadySaved } = this.state;

    const newAlreadySaved: any[] = [...unitsAlreadySaved];
    const index = newAlreadySaved.indexOf(id);
    newAlreadySaved.splice(index, 1);
    this.setState({ unitsAlreadySaved: newAlreadySaved });
    this.setUnitsToUser();
  }

  setUnitsToUser() {
    const { tableData, selectedProcessId, unitsAlreadySaved } = this.state;

    if (tableData != undefined) {
      const person = tableData.filter((item: any) => item.id == selectedProcessId);
      const index = tableData.indexOf(person[0]);
      const unitsIds: string[] = [];

      unitsAlreadySaved.map((unit: any) => {
        unitsIds.push(unit.id);
      })

      let formattedTableData: any = [...tableData];
      if (formattedTableData[index] != undefined) {
        formattedTableData[index].units = unitsAlreadySaved;
      }

      const newTableData = this.formatDataToTable(formattedTableData);

      this.setState({ tableData: newTableData });
    }
  }

  setLoadingUnitData = async (auditId: string, loading: boolean) => {
    const { unitsData } = this.state;

    const unit: any = unitsData.find((item) => {
      return item.id == auditId;
    });
    const indexOf = unitsData.indexOf(unit);

    const newUnitsData: any[] = [...unitsData];
    newUnitsData[indexOf].loading = loading;

    this.setState({ unitsData: newUnitsData });
  }

  getUnitSelectModalTitle() {
    const { selectedProcessObject } = this.state;
    if (!!selectedProcessObject) {
      return I18n.l('audits.titles.processWhatUnitWithName').replace("{name}", selectedProcessObject.name);
    }
    return I18n.l('audits.titles.processWhatUnit');
  }

  //#endregion

  //#region upoload model
  setImageValidator(modelValidator: Function) {
    // this.setState({ modelValidator })
  }
  onModalImageChanged = async (imageData: any) => {
    this.setState({ imageUpload: imageData });
  }
  validateType = async (validateExtension: any) => {
    this.setState({ modelValidatorType: validateExtension })
  }
  validateUploadModel = async (modelValidator: any) => {
    this.setState({ modelValidator: modelValidator })
    console.log('model', this.state.modelValidator)
  }

  isUploadModel = async (loading: any) => {
    this.setState({ isLoadingModel: loading })
    console.log('model is loading', this.state.isLoadingModel)
  }

  onRemoveModalImage() {
  }

  handleSubmit = async (e: any) => {
    e.preventDefault();
    this.props.form.validateFields((err: any, values: any) => {
      if (!err) {
        this.onSubmitModel();
      } else {
        console.log('Form submit Errors', err)
      }
    });
  }

  onSubmitModel = async () => {
    const { tableData, loadingRequest, editItem } = this.state;

    const form = this.props.form;

    this.setState({ loadingRequest: true });

    try {
      let nextTableData: IModel3D[] = [];
      let values = await form.getFieldsValue();

      if (editItem && editItem.id) {
        let dataEdit: any;
        console.log('URL', this.state.modelValidator)
        dataEdit = {
          id: editItem.id,
          name: values.name,
          url:  this.state.modelValidator === ''? editItem.url : this.state.modelValidator
          // buffer: this.state.imageUpload
        }

        const response = await _mode3dService.updateById(editItem.id, this.idUnit, dataEdit);
        const targetIndex = findIndex(
          tableData,
          (item: any) => item.id === response.id,
        );
        nextTableData = tableData;
        if (nextTableData[targetIndex]) {
          nextTableData[targetIndex] = Object.assign(nextTableData[targetIndex], response);
        }
        
        await NotificationComponent.Notify('success', I18n.l("common.success"), I18n.l("model3d.editModel"));
      } else {
        values = {
          id: '',
          ...values,
          url: this.state.modelValidator
        }
        const response = await _mode3dService.create(values, this.idUnit);

        nextTableData = [response, ...tableData];
        await NotificationComponent.Notify('success', I18n.l("common.success"), I18n.l("model3d.registerModel"));
      }
      const dataTableCreate: any = [];
      nextTableData.map((item: any) => {
        dataTableCreate.push({
          id: item.id,
          name: item.name,
          url: this.state.modelValidator,
          created: item.createdAt,
          action: true
        })
      })
      this.setState({ loadingRequest: false, isLoading: false, openModel3dEdit: false, openModel3dRegister: false, tableData: nextTableData });
      await this.getModels3Ds(true)
    } catch (error) {
      NotificationComponent.Notify('error', I18n.l("form.filter.errors.register"), error);
      this.setState({ loadingRequest: false });
    } finally {
    }
  }
  //#endregion
  render() {
    const { getFieldDecorator } = this.props.form;
    const values = this.props.form.getFieldsValue();

    const {
      isLoading,
      search,
      tableData,
      filteredTableData,
      offset,
      loadingMoreFormflows,
      loadingRequest,
      serverResponse,
      showUnitSelectModal,
      unitsAlreadySaved,
      unitsData,
      openModel3dRegister,
      openModel3dEdit
    } = this.state;

    if (isLoading) {
      return (
        <Page>
          <span>{I18n.l('common.loadingTable')}</span>
        </Page>
      );
    }

    return (
      <Page>
        <Wrapper>
          <Toolbar>
            <ToolbarItem>
              <RegisterBtnComponent
                onClick={this.toggleFormModal}
                buttonText={I18n.l('common.register') + " " + I18n.l('formflow.components.modelComponent.titleModelComponent')}
              />
            </ToolbarItem>
            <ToolbarItem>
              <SearchComponent
                onSubmit={this.searchModels3d}
                placeholder='form.placeholders.formflowSearch'
                defaultValue={search}
                buttonText='form.buttons.search'
              />
            </ToolbarItem>
          </Toolbar>
          {tableData.length > 0 && (
            <React.Fragment>
              <div className={'goepik-component-tablesize'}>
                <Table
                  columns={tableColumns}
                  data={filteredTableData.length > 0 ? filteredTableData : tableData}
                  onEdit={this.onEditModel3d}
                  onDelete={this.deleteModel3d}
                  noPagination={true}
                  showConfirmationModal={false}
                  labelDelete={I18n.l('model.deleteButton')}
                  descriptionDelete={I18n.l('model.deleteDescription')}
                />
              </div>

              {offset && (
                <Button
                  className="loading-more"
                  type="primary"
                  size='large'
                  ghost
                  loading={loadingMoreFormflows}
                  onClick={this.loadMoreModel3d}>{I18n.l('common.seeMore')}</Button>
              )}
            </React.Fragment>


          )}

          {tableData.length === 0 && <p>{I18n.l('common.noResult')}</p>}

          {showUnitSelectModal && (
            <SelectableDataComponent
              title={this.getUnitSelectModalTitle()}
              data={unitsData}
              showModal={showUnitSelectModal}
              loadingData={false}
              auditorAuditsIds={unitsAlreadySaved}
              onItemRemoved={this.onRemoveUnit}
              onItemSelected={this.onAddUnit}
              serverResponse={serverResponse}
              onToggleFormModal={() => this.toggleUnitSelectModal()}

              savedDefaultValues={this.state.actualUnit ? [this.state.actualUnit.name] : undefined}
              customNoSavedItemsString={I18n.l('process.titles.noUnitsSaved')}
              customNoItemsToSaveString={I18n.l('process.titles.noUnitsToSave')}
              customNoInfoString={I18n.l('process.titles.noUnitsRegistered')}
              customWhereCreateItemsInfoString={I18n.l('process.titles.whereAddUnitInfo')}
            />
          )}

          <Modal
            visible={openModel3dRegister}
            footer={false}
            destroyOnClose={true}
            onCancel={this.toggleFormModal}
          >
            <ModalTitle>{I18n.l('common.register') + " " + I18n.l('formflow.components.modelComponent.titleModelComponent')}</ModalTitle>
            <React.Fragment >
              <Form hideRequiredMark={true}>
                <Form.Item
                  label={I18n.l('form.labels.name')}
                  colon={false}
                >
                  {getFieldDecorator('name', {
                    rules: [
                      { required: true, message: I18n.l('common.fieldRequired') },
                      {
                        min: 3, message: I18n.l('form.validation.text.min')
                      },
                    ],
                    initialValue: ''
                  })(
                    <Input />
                  )}
                </Form.Item>
                <Form.Item
                  label={I18n.l('formflow.components.modelComponent.uploadTitle')}
                  colon={false}
                >
                  {getFieldDecorator('upload', {
                    rules: [{ required: false, message: I18n.l('common.fieldRequired') }],
                  })(
                    <UploadModelComponent
                      typeFile={'.fbx'}
                      onValidate={this.setImageValidator}
                      buttonTitle={I18n.l('form.labels.update.model')}
                      customListType={'picture'}
                      onFileListChange={this.onModalImageChanged}
                      onRemoveImage={this.onRemoveModalImage}
                      validateType={this.validateType}
                      validateUpload={this.validateUploadModel}
                      isLoading={this.isUploadModel}
                    />
                  )}
                </Form.Item>
                <Form.Item style={{ textAlign: 'right' }}>
                  <Button
                    style={{ marginRight: 8 }}
                    className="link primary bolder"
                    size="large"
                    onClick={this.toggleFormModal}>
                    {I18n.l('common.cancel')}
                  </Button>
                  <Button loading={this.state.loadingRequest ? true : false} disabled={this.state.isLoadingModel ? true : false} type="primary" htmlType="submit" size="large" onClick={this.handleSubmit}>{I18n.l('common.save')}</Button>
                </Form.Item>
              </Form>
            </React.Fragment>

          </Modal>

          {/* EDIT MODAL*/}
          <Modal
            visible={openModel3dEdit}
            footer={false}
            destroyOnClose={true}
            onCancel={this.toggleFormModalEdit}
          >
            <ModalTitle>{I18n.l('common.register') + " " + I18n.l('formflow.components.modelComponent.titleModelComponent')}</ModalTitle>
            <React.Fragment >
              <Form hideRequiredMark={true}>
                <Form.Item
                  label={I18n.l('form.labels.name')}
                  colon={false}
                >
                  {getFieldDecorator('name', {
                    rules: [
                      { required: true, message: I18n.l('common.fieldRequired') },
                      {
                        min: 3, message: I18n.l('form.validation.text.min')
                      },
                    ],

                    initialValue: ""
                  })(
                    <Input />
                  )}
                </Form.Item>
                <span style={{color: `${Theme.secondary.midGrey}`, marginBottom: '1rem', fontWeight: 'bold'}} >{I18n.l('model3d.lostAnimationAlert')}</span>
                <Form.Item
                  label={I18n.l('formflow.components.modelComponent.uploadTitle')}
                  colon={false}
                >
                  {getFieldDecorator('url', {
                    rules: [{ required: false, message: I18n.l('common.fieldRequired') }],
                  })(
                    <UploadModelComponent
                      typeFile={'.fbx'}
                      onValidate={this.setImageValidator}
                      buttonTitle={I18n.l('form.labels.update.model')}
                      customListType={'picture'}
                      defaultFileList={this.state.imageFileList}
                      onFileListChange={this.onModalImageChanged}
                      onRemoveImage={this.onRemoveModalImage}
                      validateType={this.validateType}
                      validateUpload={this.validateUploadModel}
                      isLoading={this.isUploadModel}
                    />
                  )}
                </Form.Item>
                <Form.Item style={{ textAlign: 'right' }}>
                  <Button
                    style={{ marginRight: 8 }}
                    className="link primary bolder"
                    size="large"
                    onClick={this.toggleFormModalEdit}>
                    {I18n.l('common.cancel')}
                  </Button>
                  <Button loading={this.state.loadingRequest ? true : false}  type="primary" htmlType="submit" size="large" onClick={this.handleSubmit}>{I18n.l('common.save')}</Button>
                </Form.Item>
              </Form>
            </React.Fragment>

          </Modal>

        </Wrapper>
      </Page >
    );
  }
}


const Wrapper = styled.div`
    display: flex;
    flex-flow: column;
    align-items: flex-start;
    justify-content: flex-start;
    width: 100%;
    .alert-animation {
      color: ${Theme.secondary.midGrey};
      margin-bottom: 1rem;
      font-weight: bold;
    }
`;

const Toolbar = styled.div`
    flex: 0;
    display: flex;
    flex-flow: row nowrap;
    margin-bottom: 40px;
    width: 100%;
`;

const ToolbarItem = styled.div`
    flex: 1;
    margin-left: 50px;
    
    &:first-of-type {
        flex: 0;
        margin-left: 0;
    }
`;

const ModalTitle = styled.h3`
  font-size: 22px;
`;

const ModalContent = styled.div`
  width: 100%;
`;

export const UploadModel3DContainer = Form.create()(Model3DClass);